module.exports = __webpack_public_path__ + "825655461469331254447e7d4b488763.png";